import { DISPLAY_TYPE_LIST, DISPLAY_TYPE_MINIMAL, DISPLAY_TYPE_TILE, DisplayType } from '../common/displayType/types';
import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useDisplayTypeSearchParam = (defaultDisplayType: DisplayType = DISPLAY_TYPE_TILE) => {
    const [searchParams, setSearchParams] = useSearchParams();

    const display = useMemo(() => {
        switch (searchParams.get('display')) {
            case DISPLAY_TYPE_MINIMAL:
                return DISPLAY_TYPE_MINIMAL;
            case DISPLAY_TYPE_TILE:
                return DISPLAY_TYPE_TILE;
            case DISPLAY_TYPE_LIST:
                return DISPLAY_TYPE_LIST;
            default:
                return defaultDisplayType;
        }
    }, [defaultDisplayType, searchParams]);

    const onDisplayChange = useCallback(
        (nextDisplayType: DisplayType) => {
            setSearchParams(
                current => {
                    current.set('display', nextDisplayType);
                    return current;
                },
                { replace: true }
            );
        },
        [setSearchParams]
    );

    return { display, onDisplayChange };
};
